import React, { useId } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/** Uppercase label + Input + optional hint, the standard settings form field. */
export function LabeledInput({ label, hint, className = "", inputClassName = "", testId, ...inputProps }) {
  const id = useId();
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Label htmlFor={id} className="text-xs font-semibold uppercase tracking-wider text-slate-700">
        {label}
      </Label>
      <Input id={id} className={`focus-visible:ring-orange-500 ${inputClassName}`} data-testid={testId} {...inputProps} />
      {hint && <p className="text-xs text-slate-500">{hint}</p>}
    </div>
  );
}
